var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.notification
    ? _c("div", { class: _vm.classes }, [
        _vm._v(" " + _vm._s(_vm.say[_vm.notification]) + " "),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }